import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Servers from "./pages/Servers";
import Tencent from "./pages/Tencent";
import Tencent80 from "./pages/Tencent80";
import Iotamine from "./pages/Iotamine";
import ZoomCookies from "./pages/ZoomCookies";
import Admin from "./pages/Admin";
import Payments from "./pages/Payments";
import Broadcast from "./pages/Broadcast";

function getUserInfo() {
  try {
    const token = localStorage.getItem("token");
    if (!token) return {};
    return JSON.parse(atob(token.split(".")[1]));
  } catch { return {}; }
}

export default function AdminApp({ onLogout }) {
  const userInfo = getUserInfo();

  return (
    <Layout userInfo={userInfo} onLogout={onLogout}>
      <Routes>
        <Route path="/"        element={<Dashboard />} />
        <Route path="/servers" element={<Servers />} />
        <Route path="/tencent" element={<Tencent />} />
        <Route path="/tencent80" element={<Tencent80 />} />
        <Route path="/iotamine" element={<Iotamine />} />
        <Route path="/zoom-cookies" element={<ZoomCookies />} />
        <Route path="/adminhanuman"   element={<Admin currentUser={userInfo.username} />} />
        <Route path="/payments" element={<Payments />} />
        <Route path="/broadcast" element={<Broadcast />} />
        <Route path="*"        element={<Navigate to="/" />} />
      </Routes>
    </Layout>
  );
}